// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";

var $$URLSearchParams = {};

var $$Blob = {};

var $$File = {};

var $$FileList = {};

function classify(t) {
  if (typeof t === "string") {
    return {
            NAME: "String",
            VAL: t
          };
  } else {
    return {
            NAME: "File",
            VAL: t
          };
  }
}

var EntryValue = {
  classify: classify
};

var $$FormData = {
  EntryValue: EntryValue
};

var $$URL = {};

var $$Location = {};

var $$History = {};

var WindowProxy = {};

var $$Window = {};

var EventListener = {};

var isBrowser = (function() {
      return typeof window !== 'undefined'
    });

function getWindow() {
  if (isBrowser()) {
    return Caml_option.some(window);
  }
  
}

var Dom = {
  isBrowser: isBrowser,
  getWindow: getWindow
};

var $$AbortSignal = {};

export {
  $$URLSearchParams ,
  $$Blob ,
  $$File ,
  $$FileList ,
  $$FormData ,
  $$URL ,
  $$Location ,
  $$History ,
  WindowProxy ,
  $$Window ,
  EventListener ,
  Dom ,
  $$AbortSignal ,
}
/* No side effect */
